/**
 * 从列表中提取指定键的值，生成对象映射
 * @param {Array<Object>} list - 源列表
 * @param {string} [key="desc"] - 用作对象键的属性名
 * @param {string} [valueKey="value"] - 用作对象值的属性名
 * @returns {Object.<string, any>} 生成的对象映射
 */
export function getValuesFromList(list, key = "desc", valueKey = "value") {
  const obj = {};
  (list || []).forEach((item) => {
    const keyValue = item[key] || "";
    const value = item[valueKey];
    if (keyValue && value) {
      obj[keyValue] = value;
    }
  });
  return obj;
}
